import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyCurrentlyPayingMortgage } = loanFormModel.formField;

class IsPayingMortgage implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isPayingMortgage =
      application[systemPropertyCurrentlyPayingMortgage.name];

    return (
      isPayingMortgage !== null &&
      isPayingMortgage !== undefined &&
      isYes(isPayingMortgage)
    );
  }
}

export default new IsPayingMortgage();
